import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=1eedbe78&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eedbe78')) {
      api.createRecord('1eedbe78', component.options)
    } else {
      api.reload('1eedbe78', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=1eedbe78&", function () {
      api.rerender('1eedbe78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Calendar.vue"
export default component.exports